import { createReducer, on } from '@ngrx/store';
import {
  COUPON_FIND_SUCCESS,
  COUPON_FAILURE,
  COUPON_RESET_ERROR,
  COUPON_RESET,
  COUPON_FIND_ALL_SUCCESS,
  COUPON_CLEAR_STATE,
  COUPON_UPDATE_LOADING,
  COUPON_VALID,
  COUPON_VALIDATED_SUCCESS,
} from '@store/actions';
import { COUPON_UPDATE_APPLIED } from '../actions/coupon.action';
import { IResponseBadRequest } from '@core/interfaces';
import { Coupon } from '@core/models';

export interface CouponState {
  loading: boolean;
  coupon: Coupon | null;
  couponList: Coupon[] | null;
  appliedCoupon: string | null;
  error: IResponseBadRequest | null;
}

export const initialState: CouponState = {
  loading: false,
  coupon: null,
  couponList: null,
  appliedCoupon: null,
  error: null,
};

export const couponReducer = createReducer(
  initialState,
  on(COUPON_FIND_SUCCESS, (state, { coupon }) => ({
    ...state,
    coupon,
  })),
  on(COUPON_VALIDATED_SUCCESS, (state, { coupon }) => ({ ...state, coupon, })),
  on(COUPON_VALID, (state, { coupon }) => ({ ...state, appliedCoupon: coupon?.code || null })),
  on(COUPON_FIND_ALL_SUCCESS, (state, { couponList }) => ({ ...state, couponList })),
  on(COUPON_FAILURE, (state, { error }) => ({ ...state, error })),
  on(COUPON_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(COUPON_UPDATE_APPLIED, (state, { code }) => ({
    ...state,
    appliedCoupon: code
  })),
  on(COUPON_RESET, (state) => ({ ...state, coupon: null, couponId: null, couponForm: null, appliedCoupon: null})),
  on(COUPON_RESET_ERROR, (state) => ({ ...state, error: null })),
  on(COUPON_CLEAR_STATE, () => initialState),
);
